<template>
    <div class="page-wrapper">
        <div class="cg-crumb">
            <span class="item">订单管理</span>
            <em class="gap">/</em>
            <span class="item">锁仓列表</span>
        </div>
        <div class="cg-main-title">
            锁仓列表
            <div class="link-wrap">
                <button class="cg-btn" @click="toListOrder">下单列表</button>
                <button class="cg-btn mgl-16" @click="toListClear">清算列表</button>
            </div>
        </div>
        <div class="header-handle">
            <div class="cg-search-box">
                <el-input
                    size="mini"
                    placeholder="ID/商品名称/款号"
                    prefix-icon="el-icon-search"
                    v-model.trim="searchWords"
                    clearable
                    >
                </el-input>
                <button class="cg-btn red" @click="searchHandle">搜索</button>
            </div>
            <!-- <div class="btns">
                <button class="cg-btn red" @click="toAddGoods">新增商品</button>
                <button class="cg-btn mgl-16" @click="exportItemInfo">下载表格</button>
            </div> -->
        </div>
        <div class="table-wrap">
            <el-table
                :data="tableData"
                v-loading="loading"
                size="small"
            >
                <!-- <el-table-column
                    type="selection"
                    align="center"
                    width="55"
                >
                </el-table-column> -->
                <el-table-column
                    align="center"
                    label="序号"
                    type="index"
                    width="80"
                    :index="indexMethod"
                >
                </el-table-column>
                <el-table-column
                    prop="order_number"
                    label="锁仓订单号"
                    width="140"
                >   
                </el-table-column>
                <el-table-column
                prop="mallItemFileUrl"
                label="图片"
                width="100">
                    <template slot-scope="scope">
                        <el-image
                            style="width: 64px; height: 64px"
                            :src="scope.row.productMainImageFile"
                            fit="cover"
                            :preview-src-list="[scope.row.productMainImageFile]"
                        >
                        </el-image>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="item_name"
                    label="商品名称"
                    width="120"
                >
                </el-table-column>
                <el-table-column
                    prop="item_style_number"
                    label="款号"
                    width="100"
                >
                </el-table-column>
                <el-table-column
                    prop="item_order_price"
                    label="价格(元)"
                    width="80"
                >
                    <template slot-scope="scope">
                        {{scope.row.item_order_price | price}}
                    </template>
                </el-table-column>
                <el-table-column
                    prop="dealerName"
                    label="销售商"
                    width="100"
                >
                </el-table-column>
                <el-table-column
                    prop="reserve_order_submit_time"
                    label="发起时间"
                    width="90"
                >
                </el-table-column>
                <el-table-column
                    prop="order_reserve_quantity"
                    label="锁仓数"
                    width="80"
                >
                </el-table-column>
                <el-table-column
                    prop="order_state"
                    label="锁仓状态"
                    width="120"
                >
                    <template slot-scope="scope">
                        <el-tag :type="tagType[scope.row.order_state]" size="medium">{{lockState[scope.row.order_state]}}</el-tag>
                    </template>
                </el-table-column>
                <el-table-column
                    label="操作"
                    min-width="160"
                >
                    <template slot-scope="scope">
                        <el-button class="cg-icon-btn" @click="toLockDetail(scope.row)" type="text" size="small">查看</el-button>
                        <el-button class="cg-icon-btn" v-if="scope.row.order_state == 2" @click="toAgreeLock(scope.row)" type="text" size="small">同意</el-button>
                        <el-button class="cg-icon-btn" v-if="scope.row.order_state == 2" @click="toRejectLock(scope.row)" type="text" size="small">拒绝</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="cg-pagination-wrap">
                <el-pagination
                    background
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="currentPage"
                    :page-sizes="[5, 10, 50, 100]"
                    :page-size="pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="total">
                </el-pagination>
            </div>
            
        </div>
    </div>
</template>

<script>
import { reserverOrderList, updateReserverOrderState } from '../../../api/supplier'
import { mapGetters } from 'vuex'
import { supplierLockOrderState } from '../../../utils/order-state'
export default {
    data() {
        return {
            loading: false,
            searchWords: '',
            tableData: [],

            // 分页
            pageSize: 10,
            total: 0,
            currentPage: 1,
            lockState: supplierLockOrderState,
            tagType: {
                0: 'info',
                1: 'success',
                2: 'warning',
                3: 'danger',
                4: 'danger',
                5: 'success'
            }
        }
    },
    computed: {
        ...mapGetters(['userId'])
    },
    created() {
        console.log(this.$route.query);
    },
    watch: {
        '$route': {
            handler: function (route) {
                this.pageSize = Number(this.$route.query.size) ? Number(this.$route.query.size) : 10
                this.currentPage = Number(this.$route.query.page) ? Number(this.$route.query.page) : 1
                this.searchWords = this.$route.query.search || ''
                this.getLockList();
            },
            immediate: true
        }
    },
    methods: {
        getLockList() {
            reserverOrderList({
                "supplierUserId": this.userId,
                "dealerUserId": "",
                "page": this.currentPage,
                "num": this.pageSize,
                "fuzzyQuery": this.searchWords
            }).then(res => {
                this.loading = false
                console.log('reserverOrderList', res)
                if (res.errorCode == 200) {
                    this.tableData = res.data.orderList.map(item => {
                        return {
                            ...item,
                            productMainImageFile: process.env.VUE_APP_IMG_PREV + item.productMainImageFile
                        }
                    })
                    this.total = parseInt(res.data.totalCount)

                } else {
                    this.$message.error(res.errorMsg || '获取列表数据失败')
                }
            }).catch(err=> {
                this.loading = false
                console.log(err)
            })
        },
        // 搜索
        searchHandle() {
            this.currentPage = 1
            this.curRoutePush()
        },
        // 去锁仓页
        toLockDetail(row) {
            this.$router.push('/supplier/order/detail-lock?orderNumber=' + row.order_number + '&itemId=' + row.item_id )
        },
        // 同意锁仓
        toAgreeLock(row) {
            this.$confirm('请仔细确认实际库存是否足够！', '提示', {
                confirmButtonText: '同意锁仓',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                updateReserverOrderState({
                    orderId: row.order_id,
                    reserveOrderNumber: row.order_number,
                    orderState: 1
                }).then(res => {
                    console.log(res)
                    if (res.errorCode == 200) {
                        this.$message({
                            type: 'success',
                            message: '同意锁仓成功!'
                        })
                        this.getLockList();
                    } else {
                        this.$message({
                            type: 'error',
                            message: res.errorMsg || '操作异常!'
                        })
                    }
                    
                }).catch(err => {
                    console.log(err)
                })
            })
        },
        // 拒绝锁仓
        toRejectLock(row) {
            this.$prompt('请输入拒绝理由，非必填', '拒绝锁仓', {
                confirmButtonText: '拒绝锁仓',
                cancelButtonText: '取消',
            }).then(({ value }) => {
                updateReserverOrderState({
                    orderId: row.order_id,
                    reserveOrderNumber: row.order_number,
                    orderState: 4,
                    orderLastUpdateMemo: value
                }).then(res => {
                    console.log(res)
                    if (res.errorCode == 200) {
                        this.$message({
                            type: 'success',
                            message: '拒绝锁仓成功!'
                        })
                        this.getLockList();
                    } else {
                        this.$message({
                            type: 'error',
                            message: res.errorMsg || '操作异常!'
                        })
                    }
                    
                }).catch(err => {
                    console.log(err)
                })
                
            })
        },

        // 序号
        indexMethod(index) {
            return this.total - this.pageSize * (this.currentPage-1) - index;
        },
        handleSizeChange(val) {
            console.log(val)
            console.log(`每页 ${val} 条`);
            this.pageSize = val
            this.currentPage = 1
            this.curRoutePush()
        },
        curRoutePush() {
            this.$router.push('/supplier/order/list-lock?search=' + this.searchWords + 
            '&page=' + this.currentPage + 
            '&size=' + this.pageSize).catch(err => {err})
        },
        handleCurrentChange(val) {
            console.log(val)
            console.log(`当前页: ${val}`);
            this.currentPage = val
            this.curRoutePush()
        },
        toListOrder() {
            this.$router.push('/supplier/order/list-order')
        },
        toListClear() {
            this.$router.push('/supplier/order/list-clear')
        },
    },
}
</script>

<style lang="scss" scoped>
.page-wrapper {
  padding: 24px 24px;
  min-width: 900px;
}
.header-handle {
    margin-top: 24px;
    padding: 20px 24px;
    height: 28px;
    background: #fff;
    .cg-search-box {
        float: left;
    }
    .btns {
        float: right;
    }
}
.table-wrap {
    margin-top: 8px
}
.el-image {
    display: block;
}
</style>